import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IIncomingInvoice } from "@/interfaces/api/incoming-invoice.interface.ts"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import DataHelper from "@/helper/data-helper"

export class IncomingInvoiceRepository extends BaseRepository<IIncomingInvoice> {
  protected resourcePath = "administration/incoming-invoices"

  public async reExport(id: string): Promise<IIncomingInvoice> {
    const response = await new HTTPRequestBuilder(
      HTTPMethods.POST,
      `${this.getResourcePath(id)}re-export/`
    )
      .build()
      .execute()

    return DataHelper.denormalizeData(response.data) as IIncomingInvoice
  }
}
